/**
 * Sprint 23.6.1 — AgentProfileSidebar.
 *
 * Composes the 4-section sidebar for a per-agent profile (per validated
 * `agent_profile_mockup_v3_with_tabs`):
 *
 *   1. Workforce position — conditional, hides when 0 reports-to AND 0
 *      sub-agents (preserved from Sprint 23.6).
 *   2. Profile             — Style / Hired / Model.
 *   3. Equipped with       — connection chips.
 *   4. Specialties         — tag pills.
 *
 * Each section renders an empty-state inline rather than collapsing the whole
 * block (Sprint 23.6.1 Q4) so the sidebar's visual rhythm stays consistent.
 */

import { type CSSProperties } from "react";
import type { LibraryNodeDetail } from "../../../lib/types";
import { AgentWorkforcePosition } from "./AgentWorkforcePosition";
import { AgentProfileMeta } from "./AgentProfileMeta";
import { AgentSpecialtiesPills } from "./AgentSpecialtiesPills";

export interface AgentProfileSidebarProps {
  node: LibraryNodeDetail;
}

export function AgentProfileSidebar({ node }: AgentProfileSidebarProps) {
  return (
    <div style={stack}>
      <AgentWorkforcePosition node={node} />
      <AgentProfileMeta node={node} />
      <AgentSpecialtiesPills node={node} />
    </div>
  );
}

const stack: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: 12,
};
